import { useEffect, useState } from 'react'

export function useUserTimeZone() {
  const [userTimeZone, setUserTimeZone] = useState('Europe/London') // fallback

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
      if (tz) {
        setUserTimeZone(tz)
      }
    }
  }, [])

  const formatTimestampForUser = (timestamp) => {
    const date = new Date(timestamp)
    return new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZoneName: 'short',
      hour12: false,
      timeZone: userTimeZone
    }).format(date)
  }

  return { userTimeZone, formatTimestampForUser }
}
